import { Component, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-property-details-illustration',
  templateUrl: './property-details-illustration.component.html',
  styleUrls: ['./property-details-illustration.component.scss'],
  standalone: false
})
export class PropertyDetailsIllustrationComponent {
  @Input()
  hasSmallImage: boolean;

  @Input()
  isIndicateurRisqueMoyenHaut: boolean;

  constructor(private readonly _renderer: Renderer2) {}

  startSmallCloudsAnimation({ target, visible }: { target: Element; visible: boolean }): void {
    if (visible) {
      this._renderer.addClass(target, 'cloud-animation-small');
    }
  }

  startLargeCloudsAnimation({ target, visible }: { target: Element; visible: boolean }): void {
    if (visible) {
      this._renderer.addClass(target, 'cloud-animation-large');
    }
  }

  startTreeAnimation({ target, visible }: { target: Element; visible: boolean }): void {
    if (visible) {
      this._renderer.addClass(target, 'tree-anim');
    }
  }
}
